import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import api from "../lib/api";
import { Mail, CheckCircle2 } from "lucide-react";

export function NewsletterSignup({ source = "unknown", compact = false, className = "" }) {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.includes("@")) { toast.error("Enter a valid email"); return; }
        setLoading(true);
        try {
            await api.post("/newsletter/subscribe", { email, source });
            setDone(true);
            toast.success("You're in. Watch for tomorrow's fact.");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Could not subscribe");
        } finally {
            setLoading(false);
        }
    };

    if (done) {
        return (
            <div className={`flex items-center gap-3 text-emerald-300 ${className}`} data-testid="newsletter-success">
                <CheckCircle2 className="h-5 w-5" />
                <span className="text-sm font-medium">Subscribed. One fact a day, straight to your inbox.</span>
            </div>
        );
    }

    if (compact) {
        return (
            <form onSubmit={submit} className={`flex gap-2 ${className}`}>
                <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com"
                    className="bg-white/5 border-white/10 h-10 text-sm"
                    data-testid={`newsletter-input-${source}`}
                    required
                />
                <Button
                    type="submit"
                    disabled={loading}
                    data-testid={`newsletter-submit-${source}`}
                    className="rounded-full bg-primary text-primary-foreground text-sm font-semibold px-5"
                >
                    {loading ? "…" : "Subscribe"}
                </Button>
            </form>
        );
    }

    return (
        <div className={`card-surface rounded-2xl p-8 ${className}`}>
            <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-primary/20 border border-primary/40 flex items-center justify-center">
                    <Mail className="h-5 w-5 text-accent" />
                </div>
                <div>
                    <h3 className="font-display text-xl text-accent">Fact of the Day</h3>
                    <p className="text-xs text-muted-foreground">One viral claim + verdict, every morning.</p>
                </div>
            </div>
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
                <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com"
                    className="bg-white/5 border-white/10 h-11 flex-1"
                    data-testid={`newsletter-input-${source}`}
                    required
                />
                <Button
                    type="submit"
                    disabled={loading}
                    data-testid={`newsletter-submit-${source}`}
                    className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold h-11"
                >
                    {loading ? "Subscribing…" : "Subscribe free"}
                </Button>
            </form>
            <p className="text-[11px] text-muted-foreground mt-3">
                No spam. Unsubscribe anytime. We never sell your email.
            </p>
        </div>
    );
}
